define("BTM.DomainRestriction.DomainRestriction.Model",["Backbone","Utils"],function(e,t){"use strict";return e.Model.extend({urlRoot:t.getAbsoluteUrl(getExtensionAssetsPath("services/DomainRestriction.Service.ss"))})});
